<template>
  <div>
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 45px;
      "
      class="col form-group"
    >
      <select style="height: 35px; margin-top: 10px" class="w-100 c-select" v-model="objTeam">
        <option style="color: black" value="" disabled hidden>
          {{ getTextInputFavoriteTeam() }}
        </option>
        <option style="color: black" v-for="(team, index) in obj.data" :value="team" :key="index">
          {{ team.entityName }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
/* Services */
import axios from 'axios'

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FavoriteTeam',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    objTeam: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject']),
  },
  mounted() {
    this.getTeamsByOwner()
    this.getTextInputFavoriteTeam()
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    getTextInputFavoriteTeam() {
      if (this.config.ownerId == 169) return 'Escolha a sua federação'
      else return 'Escolha seu time do coração'
    },
    getTeamsByOwner() {
      const url = `https://fanpageapi.fanbase.com.br/api/Events/getSubListByOwnerId/${this.config.ownerId}`
      axios.get(url).then(
        response => {
          this.obj = response.data
        },
        error => {
          alert(error)
        },
      )
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      let objTeam = {}

      objTeam.team = this.objTeam.id

      if (!this.objTeam) {
        hasErrors = true
        this.addRegistrationError({ msg: 'É necessário escolher uma opção' })
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', objTeam)

        this.$emit('next')
      }
    },
  },
}
</script>
